import IActiveOrInactiveDTO from 'modules/veiculos/domain/dtos/IActiveOrInactiveDTO'
import ICreateVeiculoDTO from 'modules/veiculos/domain/dtos/ICreateVeiculoDTO'
import TipoCarreta from 'modules/veiculos/domain/entities/TipoCarreta'
import Veiculo from 'modules/veiculos/domain/entities/Veiculo'

import { client } from 'shared/services/ServiceConfig'
import IFindAll from '../../domain/dtos/IFindAll'
import VeiculoPaginate from '../../domain/entities/VeiculoPaginate'
import IVeiculosRepository from '../../domain/repositories/IVeiculosRepository'

export default class VeiculosRepository implements IVeiculosRepository {
  public async findAll(params: IFindAll): Promise<VeiculoPaginate> {
    const response = await client.get('/veiculos', { params })
    return response.data
  }

  public async activeOrInactive(param: IActiveOrInactiveDTO): Promise<void> {
    const query = `/veiculos/${param.veiculo.id}`
    await client.patch(query, {
      ativo: param.veiculo.ativo,
    })
  }

  public async delete(id: number): Promise<void> {
    const query = `/veiculos/${id}`
    await client.delete(query)
  }

  public async findAllTipoCarretas(): Promise<TipoCarreta[]> {
    const response = await client.get('/tipos-carreta')
    return response.data
  }

  public async create(data: ICreateVeiculoDTO): Promise<Veiculo> {
    const response = await client.post('/veiculos', data)
    return response.data
  }

  public async getImagemVeiculo(id: number): Promise<string> {
    const query = `/veiculos/imagem/${id}`
    const response = await client.get(query)
    return response.data
  }
}
